import React from 'react';
import { Operation } from '../../Transactions.types';
import * as S from './OperationListItem.styles';
import { SmallChevronIcon } from '@/components/UI/Icons/Icons';
import { formatNumber } from '@/utils/helpers';

interface OperationListItemProps {
  operation: Operation;
  onShowDetails: (operation: Operation) => void;
}

export function OperationListItem({
  operation,
  onShowDetails,
}: OperationListItemProps) {
  const isIncome = operation.direction === 'income';

  return (
    <S.Item onClick={() => onShowDetails(operation)}>
      <S.Content>
        <S.TopRow>
          <S.ServiceName title={operation.serviceName}>
            {operation.serviceName}
          </S.ServiceName>
          <S.Amount $isIncome={isIncome}>
            {!isIncome && '−'}
            {formatNumber(operation.amount, 2)} ₼
          </S.Amount>
        </S.TopRow>

        <S.BottomRow>
          {operation.ad ? (
            <S.Meta title={`№ ${operation.operationNumber}`}>
              № {operation.operationNumber}
            </S.Meta>
          ) : (
            <S.Meta />
          )}
          <S.Meta title={operation.date}>{operation.date}</S.Meta>
        </S.BottomRow>
      </S.Content>

      <S.Chevron>
        <SmallChevronIcon width={6} height={12} />
      </S.Chevron>
    </S.Item>
  );
}
